const History = () => {
    return <h1>Coming soon!</h1>
}

export default History;